export class MediaSearchCommandModel {
    public mediaName: string;
    public mediaTypeCode: string;
    public mediaHashtagIds: string[];
    public mediaUseCode: string;
    public languageCode: string;
    public isMediaText: boolean;
    public isMediaLibrary: boolean;
    public entityExclude: string[];
}